// src/utils/scopeResolution.js
//
// Single resolution point for "which boundary IDs should this feed use", replacing the
// ternary that was independently duplicated across ~10 sites in App.js plus
// useDirectoryListings.js (docs/escalations/2026-09-01-visit-scope-creation-footgun.md).
//
// Precedence: an active temporary visit (Change 3) always wins — the user deliberately chose to
// browse elsewhere. Otherwise the caller's own already-resolved fallback (home boundary IDs, or
// whatever else that call site was falling back to) is used unchanged.
//
// This is a pure, synchronous combinator — it holds no cache and makes no request.
export function resolveScopeBoundaryIds({ fallbackBoundaryIds, visitBoundaryIds } = {}) {
  if (visitBoundaryIds?.length > 0) return visitBoundaryIds;
  return fallbackBoundaryIds;
}

// The member's own parish for an area: the ONE rule for "which parish is this member's", used by
// the header, weather, directory, chat and the post forms alike
// (docs/briefs/2026-09-29-own-parish-everywhere.md).
//
// The base parish (user_areas.primary_boundary_id) when the area has one; otherwise the FIRST saved
// boundary. First, because that is where areas store their base parish (41 of the 45 areas that
// have one, and never last, read 29 Sep 2026), and it is what the header — the name the member
// reads — already used. Returns a Number, or null when the area has neither.
//
// A visit is not an area: callers that honour a visit check it before calling this.
export function baseParishId(area) {
  const id = area?.primary_boundary_id
    ?? (Array.isArray(area?.boundary_ids) && area.boundary_ids.length > 0 ? area.boundary_ids[0] : null);
  return id == null || id === '' ? null : Number(id);
}
